'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useCallback, useEffect } from 'react';
import { FormattedReactMessage } from 'LearningCenterUI/components/I18n';
import { connect } from 'react-redux';
import { getTrack, getTracksAreRequesting } from '../../selectors/trackSelectors';
import ContentCardSkeleton from '../../components/TrackCard/ContentCardSkeleton';
import LessonCardContainer from '../../components/LessonCard/LessonCardContainer';
import TrackCardContainer from '../TracksPage/TrackCardContainer';
import { List } from 'immutable';
import { fetchPublicTracks, getRecommendedTracks } from '../../actions/TrackActions';
import UsageTracker from '../../utils/UsageTracker';
import { SCREENS, SUB_SCREENS } from '../../constants/Tracking';
import styled, { mediaQuery, css } from '../../utils/Styling';
import ApiError from '../../components/Errors/ApiError';
import TrackRecommendationsGrid from './TrackRecommendationsGrid';
import { useFetchTracksLessonsData } from '../../hooks/catalogPageHooks';
import SectionHeading from '../../components/SectionHeading';
const MobilePadded = styled.div.withConfig({
  displayName: "TrackRecommendationsPageContainer__MobilePadded",
  componentId: "py94sp-0"
})(["margin-top:24px;padding-left:12px;padding-right:12px;", ""], mediaQuery('notTablet', css(["padding-left:30px;padding-right:30px;"])));

const TrackRecommendationsPageContainer = ({
  trackName,
  trackId,
  getRecommendedTracks: fetchRecommendations,
  hasError,
  recentError,
  isRequesting,
  recommendations
}) => {
  useEffect(() => {
    UsageTracker.track('subpageView', {
      screen: SCREENS.TRACK,
      subscreen: SUB_SCREENS.RECOMMENDATIONS,
      trackId
    });
  }, [trackId]);
  useEffect(() => {
    fetchRecommendations(trackId);
  }, [fetchRecommendations, trackId]);
  useFetchTracksLessonsData();
  const trackRecommendedCardClick = useCallback((recommendation, index) => () => {
    const recommendationMetadata = recommendation.get('recommendationMetadata');
    UsageTracker.track('interaction', {
      action: 'track-end-recommendation-card-click',
      cardNumber: index + 1,
      lessonId: recommendation.get('recommendationType') === 'LESSON' && recommendation.get('recommendationId'),
      trackId: recommendation.get('recommendationType') === 'TRACK' && recommendation.get('recommendationId'),
      recommendationStrategy: recommendation.get('recommendationStrategy'),
      preferredTopic: recommendationMetadata.get('preferredTopic'),
      recommendedBecauseTrackId: recommendationMetadata.get('entityType') && recommendationMetadata.get('entityType') === 'TRACK' && recommendationMetadata.get('entityId'),
      recommendedBecauseLessonId: recommendationMetadata.get('entityType') && recommendationMetadata.get('entityType') === 'LESSON' && recommendationMetadata.get('entityId')
    });
  }, []);

  if (hasError) {
    return /*#__PURE__*/_jsx(ApiError, {
      error: recentError
    });
  }

  if (!isRequesting && recommendations.size < 3) {
    return null;
  }

  return /*#__PURE__*/_jsxs(MobilePadded, {
    "data-test-id": "track-recommendations-page",
    children: [/*#__PURE__*/_jsx("div", {
      className: "m-bottom-6",
      children: /*#__PURE__*/_jsx(SectionHeading, {
        subText: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "learningCenter.tracks.recommendations.body",
          options: {
            trackName
          }
        }),
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "learningCenter.tracks.recommendations.heading"
        })
      })
    }), /*#__PURE__*/_jsx(TrackRecommendationsGrid, {
      children: isRequesting ? /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(ContentCardSkeleton, {}), /*#__PURE__*/_jsx(ContentCardSkeleton, {}), /*#__PURE__*/_jsx(ContentCardSkeleton, {})]
      }) : recommendations.slice(0, 3).map((recommendation, index) => recommendation.get('recommendationType') === 'LESSON' ? /*#__PURE__*/_jsx(LessonCardContainer, {
        appearsIn: "recommendations",
        lessonId: Number(recommendation.get('recommendationId')),
        onClick: trackRecommendedCardClick(recommendation, index),
        position: index + 1
      }, recommendation.get('recommendationId')) : /*#__PURE__*/_jsx(TrackCardContainer, {
        appearsIn: "recommendations",
        isUnfilterable: true,
        onClick: trackRecommendedCardClick(recommendation, index),
        position: index + 1,
        trackId: Number(recommendation.get('recommendationId'))
      }, recommendation.get('recommendationId')))
    })]
  });
};

const mapStateToProps = (state, props) => {
  const {
    trackId
  } = props;
  const {
    tracks
  } = state;
  const track = getTrack(state, {
    trackId
  });
  return {
    trackName: track.get('name'),
    hasError: tracks.getIn(['recommendedTracks', 'hasError'], false),
    recentError: tracks.getIn(['recommendedTracks', 'recentError']),
    isRequesting: tracks.getIn(['recommendedTracks', 'isRequesting'], false) || getTracksAreRequesting(state),
    recommendations: tracks.getIn(['recommendedTracks', 'bySeedTrackId', track.get('id')], List())
  };
};

const mapDispatchToProps = {
  fetchPublicTracks,
  getRecommendedTracks
};
export default connect(mapStateToProps, mapDispatchToProps)(TrackRecommendationsPageContainer);